import { create } from 'zustand';

/**
 * Whether the notification centre and a person's notification settings are
 * open. The request of 7 October 2026, section 2.
 *
 * In a store because three things open the centre: the bell in the top bar,
 * View all on the home screen, and nothing else may ever need to know how. The
 * shell draws both panels once, over whatever screen is showing.
 */
interface NotificationCenterState {
  open: boolean;
  settingsOpen: boolean;
  show: () => void;
  hide: () => void;
  showSettings: () => void;
  hideSettings: () => void;
}

export const useNotificationCenter = create<NotificationCenterState>((set) => ({
  open: false,
  settingsOpen: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
  showSettings: () => set({ settingsOpen: true }),
  hideSettings: () => set({ settingsOpen: false }),
}));
